export const ENTITY_SEARCH_REQUEST = 'ENTITY_SEARCH_REQUEST';
export const ENTITY_SEARCH_SUCCESS = 'ENTITY_SEARCH_SUCCESS';
export const ENTITY_SEARCH_FAILURE = 'ENTITY_SEARCH_FAILURE';

export const ENTITY_SEARCH_ALL_REQUEST = 'ENTITY_SEARCH_ALL_REQUEST';
export const ENTITY_SEARCH_ALL_SUCCESS = 'ENTITY_SEARCH_ALL_SUCCESS';
export const ENTITY_SEARCH_ALL_FAILURE = 'ENTITY_SEARCH_ALL_FAILURE';

export const RESET_OPTIONS = 'RESET_OPTIONS';
